import steps from "./steps";
import { resolveStepName } from "./stepNames";

const findStep = (currentStep) => {
  const resolvedName =
    typeof currentStep === "string" ? resolveStepName(currentStep) : currentStep;

  const objectSteps = steps.reduce((acc, step, index) => {
    step.index = index;
    acc[step.name || index] = step;
    return acc;
  }, {});

  return objectSteps[resolvedName];
};

export default findStep;
